import React from 'react';
import clsx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core';
import { Box, Typography, Hidden } from '@material-ui/core';
import { FooterLogo, FooterLogoMobile } from 'asset/images';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    minWidth: '1200px',
    color: '#999999',
    borderTop: '1px solid rgba(239, 239, 239, 1.0)',
    backgroundColor: '#FFF',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      minWidth: '320px',
      marginBottom: '15px',
    },
  },
  teamLogoContainer: {
    height: '87px',
    maxWidth: '840px',
    margin: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: '15px',
    paddingRight: '15px',
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    listStyle: 'none',
    [theme.breakpoints.down('md')]: {
      height: '70px',
      maxWidth: '400px',
    },
    '& > li': {
      '& > a': {
        display: 'inline-block',
        width: '77px',
        [theme.breakpoints.down('md')]: {
          width: 'auto',
          maxWidth: '40px',
        },
        '& > img': {
          width: '100%',
          [theme.breakpoints.down('md')]: {
            maxWidth: '40px',
          },
        },
      },
    },
  },
  informationContainer: {
    height: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    listStyle: 'none',
    margin: '0',
    paddingLeft: '15px',
    paddingRight: '15px',
    fontSize: '14px',
    backgroundColor: '#F5F5F5',
    [theme.breakpoints.down('md')]: {
      height: '30px',
      fontSize: '11px',
    },
    '& > li + li::before': {
      content: '"|"',
      fontSize: '10px',
      paddingLeft: '20px',
      paddingRight: '20px',
    },
    '& > li > a': {
      color: '#999',
      textDecoration: 'none',
    },
    '& > li > a:hover': {
      color: '#777',
    },
  },
  brandLogoContainer: {
    height: '97px',
    marginTop: '15px',
    marginBottom: '15px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      height: '55px',
    },
  },
  brandLogo: {
    maxHeight: '97px',
    [theme.breakpoints.down('md')]: {
      maxHeight: '55px',
    },
  },
  address: {
    fontSize: '14px',
    fontStyle: 'normal',
    paddingLeft: '15px',
    paddingRight: '15px',
    [theme.breakpoints.down('md')]: {
      fontSize: '11px',
    },
  },
  copyRight: {
    margin: 0,
    paddingLeft: '15px',
    paddingRight: '15px',
    paddingBottom: '80px',
    fontSize: '14px',
    [theme.breakpoints.down('md')]: {
      paddingBottom: '15px',
      fontSize: '11px',
    },
  },

  grayBackground: {
    backgroundColor: '#f5f5f5',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    listStyle: 'none',
    fontSize: '1.1em',
  },
  contentsContainer: {
    margin: 'auto',
  },
  addressContainer: {},
}));

function Footer() {
  const classes = useStyles();
  return (
    <footer className={classes.root}>
      <ul className={classes.teamLogoContainer}>
        <li>
          <a>
            <img src="https://www.wkbl.or.kr/static/images/team/teamlogo_03.png" />
          </a>
        </li>
        <li>
          <a>
            <img src="https://www.wkbl.or.kr/static/images/team/teamlogo_07.png" />
          </a>
        </li>
        <li>
          <a>
            <img src="https://www.wkbl.or.kr/static/images/team/teamlogo_05.png" />
          </a>
        </li>
        <li>
          <a>
            <img src="https://www.wkbl.or.kr/static/images/team/teamlogo_09.png" />
          </a>
        </li>
        <li>
          <a>
            <img src="https://www.wkbl.or.kr/static/images/team/teamlogo_11.png" />
          </a>
        </li>
        <li>
          <a>
            <img src="https://www.wkbl.or.kr/static/images/team/teamlogo_01.png" />
          </a>
        </li>
      </ul>
      <ul className={classes.informationContainer}>
        <li>
          <a href="mailto:yaimmar@kbsn.co.kr">CONTACT US</a>
        </li>
        <li>
          <a href="http://wkbl.or.kr" target="_blank">
            WKBL
          </a>
        </li>
        <li>
          <a href="http://datalab.wkbl.or.kr" target="_blank">
            데이터랩
          </a>
        </li>
      </ul>
      <Box className={classes.brandLogoContainer}>
        <Hidden only={['xs', 'sm', 'md']}>
          <img className={classes.brandLogo} src={FooterLogo} />
        </Hidden>
        <Hidden lgUp>
          <img className={classes.brandLogo} src={FooterLogoMobile} />
        </Hidden>
      </Box>
      {/* <p></p> 태그 안에는 인라인 엘리먼트만 들어갈 수 있다. */}
      <Typography component="address" className={classes.address}>
        {/* <address className={classes.address}> */}
        서울특별시 강서구 공항대로 335(등촌동) TEL : 02-752-7493
        {/* </address> */}
      </Typography>
      <Typography className={classes.copyRight}>
        COPYRIGHT &copy; 2020 WOMEN'S KOREAN BASKETBALL LEAGUE ALL RIGHTS RESERVED.
      </Typography>
    </footer>
  );
}

export default Footer;
